import { render, staticRenderFns } from "./WorkspaceVisibilityInfo.vue?vue&type=template&id=36a44f2c&"
import script from "./WorkspaceVisibilityInfo.vue?vue&type=script&lang=ts&"
export * from "./WorkspaceVisibilityInfo.vue?vue&type=script&lang=ts&"
import style0 from "./WorkspaceVisibilityInfo.vue?vue&type=style&index=0&id=36a44f2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports